import React from "react";
import Tilt from "react-parallax-tilt";
import html from "../../images/html.png";
import css from "../../images/css.png";
import js from "../../images/js.png";
import react from "../../images/react.png";
import redux from "../../images/redux.png";
import node from "../../images/node.png";
import express from "../../images/express.png";
import mongo from "../../images/mongo.png";
import graph from "../../images/graphql.png";
import framer from "../../images/framer.png";
import ml from "../../images/ml.png";
import tailwind from "../../images/tailwind.png";
import chakra from "../../images/chakra.jpg";
import flask from "../../images/flask.png";
import python from "../../images/python.png";
import swiper from "../../images/swiper.png";
import firebase from "../../images/firebase.png";
import figma from "../../images/figma.png";
import { motion } from "framer-motion";

const Card = () => {
  return (
    <div className="flex w-full cursor-pointer px-12 justify-center mt-16 flex-wrap gap-10">
      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-orange-600"
        >
          <img src={html} alt="html" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-blue-600"
        >
          <img src={css} alt="css" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-yellow-400"
        >
          <img src={js} alt="js" className="w-16 h-11" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-green-200"
        >
          <img src={python} alt="python" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-blue-400"
        >
          <img src={react} alt="react" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>     
      
      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-purple-900"
        >
          <img src={redux} alt="redux" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-green-600"
        >
          <img src={node} alt="node" className="w-10 h-12" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-black"
        >
          <img src={express} alt="express" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-blue-500"
        >
          <img src={flask} alt="flask" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-black"
        >
          <img src={ml} alt="ml" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-green-600"
        >
          <img src={mongo} alt="mongodb" className="w-12 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-pink-500"
        >
          <img src={graph} alt="graphql" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-teal-500"
        >
          <img src={tailwind} alt="tailwind" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-teal-300"
        >
          <img src={chakra} alt="chakra" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-pink-500"
        >
          <img src={framer} alt="framer" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-blue-500"
        >
          <img src={swiper} alt="swiper" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>     

      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-indigo-600"
        >
          <img src={firebase} alt="firebase" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>      
      
      <Tilt>
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 cursor-pointer flex justify-center items-center rounded-full bg-white shadow-2xl shadow-red-500"
        >
          <img src={figma} alt="figma" className="w-10 h-10" />
        </motion.div>{" "}
      </Tilt>            
    </div>
  );
};

export default Card;
